import { PropTypes } from 'prop-types';
import React from 'react';
import CircleCheckMarkIcon from '@icons/CircleCheckMarkIcon';
import Circle from '@atoms/Circle';
import SubmitButton from '@atoms/SubmitButton';

export const Success = ({ complete }) => (
    <div style={styles.container}>
        <Circle status="success">
            <CircleCheckMarkIcon />
        </Circle>

        <h3 style={{ fontSize: '2rem', marginBottom: '1.5rem', marginTop: '.7rem' }}>Thank You</h3>

        <SubmitButton onClick={complete}>Close Window</SubmitButton>
    </div>
);

Success.propTypes = {
    complete: PropTypes.func,
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flexGrow: 1,
    },
};
